module.exports = __webpack_public_path__ + "static/media/team-icon.dfde5704.svg";